import { ReplaySubject } from 'rxjs/ReplaySubject';
import { enLang } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';
import { Cookies } from 'react-cookie';
import { translateService } from 'services/TranslateService';

const cookie = new Cookies();

export class LangService {
  private lang$ = new ReplaySubject<enLang>(1);

  constructor() {
    let lang = enLang.PT_BR;
    try {
      lang = (cookie.get('lang') as enLang) || enLang.PT_BR;
    } catch (err) {}

    this.setLang(lang);
  }

  public setLang(lang: enLang) {
    try {
      cookie.set('lang', lang, {
        maxAge: 864000
      });
    } catch (err) {}

    translateService.setLang(lang);

    this.lang$.next(lang);
  }

  public getLang(): Observable<enLang> {
    return this.lang$.asObservable().distinctUntilChanged();
  }
}

// tslint:disable-next-line:variable-name
export const LangServiceFactory = () => new LangService();

export const langService = LangServiceFactory();
